var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-text", {
                  attrs: {
                    afterIcon: [
                      {
                        name: "search",
                        click: true,
                        callbackName: "searchWorkPermit",
                      },
                      {
                        name: "close",
                        click: true,
                        callbackName: "removeWorkPermit",
                      },
                    ],
                    editable: _vm.editable,
                    readonly: true,
                    label: "작업허가번호",
                    name: "permitNo",
                  },
                  on: {
                    searchWorkPermit: _vm.searchWorkPermit,
                    removeWorkPermit: _vm.removeWorkPermit,
                  },
                  model: {
                    value: _vm.searchParam.permitNo,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "permitNo", $$v)
                    },
                    expression: "searchParam.permitNo",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-process", {
                  attrs: {
                    editable: _vm.editable,
                    label: "LBLPROCESS",
                    name: "processCd",
                  },
                  model: {
                    value: _vm.searchParam.processCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "processCd", $$v)
                    },
                    expression: "searchParam.processCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-text", {
                  attrs: {
                    afterIcon: [
                      {
                        name: "search",
                        click: true,
                        callbackName: "searchWorkName",
                      },
                      {
                        name: "close",
                        click: true,
                        callbackName: "removeWorkName",
                      },
                    ],
                    editable: _vm.editable,
                    readonly: true,
                    close: false,
                    label: "LBLJOB",
                    name: "sopName",
                  },
                  on: {
                    searchWorkName: _vm.searchWorkName,
                    removeWorkName: _vm.removeWorkName,
                  },
                  model: {
                    value: _vm.searchParam.sopName,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "sopName", $$v)
                    },
                    expression: "searchParam.sopName",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-vendor", {
                  attrs: {
                    editable: _vm.editable,
                    label: "업체",
                    name: "vendorCd",
                  },
                  model: {
                    value: _vm.searchParam.vendorCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "vendorCd", $$v)
                    },
                    expression: "searchParam.vendorCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-datepicker", {
                  attrs: {
                    range: true,
                    label: "작업기간",
                    defaultStart: "-6M",
                    defaultEnd: "6M",
                    name: "period",
                  },
                  model: {
                    value: _vm.period,
                    callback: function ($$v) {
                      _vm.period = $$v
                    },
                    expression: "period",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    comboItems: _vm.statusItems,
                    type: "search",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "tbmCompleteFlag",
                    label: "작성상태",
                  },
                  model: {
                    value: _vm.searchParam.tbmCompleteFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "tbmCompleteFlag", $$v)
                    },
                    expression: "searchParam.tbmCompleteFlag",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "TBM 목록",
            columns: _vm.grid.columns,
            gridHeight: _vm.grid.height,
            data: _vm.grid.data,
            columnSetting: false,
            isFullScreen: false,
            usePaging: false,
            expandAll: true,
          },
          on: { linkClick: _vm.linkClick },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  col.name === "noUpload"
                    ? [
                        _c(
                          "q-chip",
                          {
                            class:
                              props.row.noUpload === "N" ? null : "blinking",
                            attrs: {
                              color:
                                props.row.noUpload === "N" ? "blue" : "red",
                              outline: "",
                              square: "",
                              "text-color": "white",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  props.row.noUpload === "N"
                                    ? "업로드"
                                    : "미업로드"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable
                    ? _c("c-btn", {
                        attrs: { label: "LBLREG", icon: "add" },
                        on: { btnClicked: _vm.linkClick },
                      })
                    : _vm._e(),
                  _c("c-btn", {
                    attrs: { label: "LBLSEARCH", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }